(function() {
    var highlightNumbersBlocks = document.querySelectorAll('.block-highlight-numbers');
    for (var i = 0; i < highlightNumbersBlocks.length; i++) {
        var el = highlightNumbersBlocks[i];
        var container = el.closest('.row');
        if (container !== null && !container.classList.contains('row-flex')) {
            container.classList.add('row-flex');
        }
    }
}());